import { Item } from "types/Item";
import BaseApiService from "../BaseApiService";

interface ProductsResponse {
	data: Item[];
	meta: {};
}

interface ProductResponse {
	data: Item;
	meta: {};
}

export default class Products extends BaseApiService {
	private static instance: Products;
	private baseUrl: string;

	private constructor() {
		super();
		this.baseUrl = process.env["REACT_APP_API_URL"]!.concat("/api/products");
		Products.instance = this;
	}

	public static getInstance() {
		if (!Products.instance) return new this();
		return Products.instance;
	}

	public async findAll(): Promise<ProductsResponse> {
		const path = this.baseUrl;
		try {
			return await this.getRequest(path, { Authorization: `Bearer ${process.env["REACT_APP_API_KEY"]}` });
		} catch (err) {
			return this.onError(err);
		}
	}

	public async findOne(id: string): Promise<ProductResponse> {
		const path = `${this.baseUrl}/${id}`;
		try {
			return await this.getRequest(path, { Authorization: `Bearer ${process.env["REACT_APP_API_KEY"]}` });
		} catch (err) {
			return this.onError(err);
		}
	}
}
